/*
create EvOccMappingComponen standalone, hope this can be easily use in somewhere else
  notes : uses micro service data modal
          perhas need a util convert/mapping from micro to event form data model in the future use
*/

import {
    Component,
    ChangeDetectionStrategy,
    Input,
    ChangeDetectorRef,
    ViewEncapsulation,
    OnInit,
    signal,
    Output,
    EventEmitter,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { S25IconComponent } from "../modules/s25-icon/s25.icon.component";
import { OccurrenceI } from "../pojo/OccurrenceI";
import { S25Util } from "../util/s25-util";
import { S25Reservation } from "../modules/s25-event/ReservationI";
import { S25ItemI } from "../pojo/S25ItemI";
import { EventService } from "../services/event.service";
import { S25ReservationUtil } from "../modules/s25-event/utils/s25.reservation.util";
import { UserprefService } from "../services/userpref.service";
import { S25Datefilter } from "../modules/s25-dateformat/s25.datefilter.service";
import { dataI } from "../modules/s25-event/s25-event-occurrences/ev-occ-menu/ev-occ-menu.component";
import { S25EditableModule } from "../modules/s25-editable/s25.editable.module";
import { S25ItemModule } from "../modules/s25-item/s25.item.module";
import { EventOccUtil } from "../modules/s25-event/s25-event-occurrences/s25-event-occurrence/s25.event.occurrence.util";
import { ProfileListUtil } from "../modules/student-housing/profile/profile.list.util";
import { S25ProfileUtil } from "../modules/s25-event/utils/s25.profile.util";
import { S25EventOccurrencesService } from "../modules/s25-event/s25-event-occurrences/s25.event.occurrences.service";
import { BOARD_CONST } from "../modules/s25-swarm-schedule/s25.board.const";
import { Proto } from "../pojo/Proto";
import DowNumber = Proto.DowNumber;

interface Reservation {
    itemId: number;
    date: string;
    start: string;
    end: string;
    resources: S25ItemI[];
    locations: S25ItemI[];
}

@Component({
    imports: [S25EditableModule, S25IconComponent, S25ItemModule, FormsModule, CommonModule],
    selector: "s25-ng-occ-mapping",
    template: `@if (init) {
        <div class="c-margin-bottom--single c-margin-top--single" aria-label="Copy Segment Occurrences" tabindex="0">
            <div class="ngBold">
                @if (repetitionText) {
                    <div>Initial Segment: {{ repetitionText }}</div>
                }
                @if (newRsrvRepetitionText && removeMappingItems.length === 0) {
                    <div>Copy Segment: {{ newRsrvRepetitionText }}</div>
                }
            </div>
            <div class="copy-segment-container c-margin-top--half">
                <section class="input-data">
                    <label class="c-margin-bottom--quarter c-margin-top--half" for="segmentName"> Segment Name</label>
                    @if (profileName()) {
                        <s25-ng-editable-text
                            class="segmentName"
                            [allowEmpty]="false"
                            [min]="2"
                            [max]="40"
                            [alwaysEditing]="true"
                            [val]="profileName()"
                            (valChange)="profileName.set($event)"
                        ></s25-ng-editable-text>
                    }
                    <label class="c-margin-bottom--quarter c-margin-top--half" for="startDateContainer"
                        >Start Date and Time</label
                    >

                    <s25-ng-editable-start-end-datetime
                        [startDatetime]="startDate"
                        (startDatetimeChange)="onDateTimeChange($event, 'start')"
                        [endDatetime]="endDate"
                        (endDatetimeChange)="onDateTimeChange($event, 'end')"
                        [noTimeUpdated]="true"
                    >
                    </s25-ng-editable-start-end-datetime>

                    <label class="c-margin-top--half" for="occurrenceDetails"> Occurrence Mapping </label>
                    <select
                        class="ngListPageDropdown c-margin-bottom--half"
                        [(ngModel)]="mapping"
                        (ngModelChange)="updateMapping()"
                        id="occurrenceDetails"
                        name="occurrenceDetails"
                    >
                        <option value="one-by-one">One-to-one</option>
                        <option value="date-by-date">Date-to-date</option>
                        <option value="none">No Mapping</option>
                    </select>

                    <section class="c-margin-top--half">
                        @if (repetitionText && removeMappingItems.length > 0) {
                            <section class="cn-alert cn-alert--info cn-alert--notRealConflict">
                                <section class="cn-alert__icon cn-icon cn-alert__icon--blue" name="alert--info">
                                    Warning: Selecting “Remove” will remove the repeating pattern from the event
                                    segment.
                                </section>
                            </section>
                        }
                    </section>
                </section>

                <div class="divider"></div>
                <section class="occurrence-view">
                    @for (res of reservations; track res.date + "-" + i; let i = $index) {
                        <div class="original-occurrence" [ngClass]="{ 'date-mapped': mapping === 'date-by-date' }">
                            <div class="occurrence-date" [ngClass]="{ mapped: showMapping }">
                                <div>{{ res.date }}</div>
                            </div>
                            <div class="occurrence-times">
                                <div>{{ res.start }}</div>
                                <div>{{ res.end }}</div>
                            </div>

                            <div>
                                @for (location of res.locations; track location.itemId + "-" + i; let i = $index) {
                                    <div>
                                        <s25-item-space
                                            [modelBean]="{ itemId: location.itemId }"
                                            [includeTypeIcon]="true"
                                        ></s25-item-space>
                                    </div>
                                }
                                @for (resource of res.resources; track resource.itemId + "-" + i; let i = $index) {
                                    <div>
                                        <s25-item-resource
                                            [modelBean]="{ itemId: resource.itemId }"
                                            [includeTypeIcon]="true"
                                        ></s25-item-resource>
                                    </div>
                                }
                            </div>

                            <div class="mapped-occurrence">
                                <s25-ng-icon [type]="'arrowRightDown'"></s25-ng-icon>

                                <div class="occurrence-date">{{ newReservations[i].date }}</div>
                                <div class="occurrence-times">
                                    <div>{{ newReservations[i].start }}</div>
                                    <div>{{ newReservations[i].end }}</div>
                                </div>
                                <div
                                    class="occurrence-objects"
                                    [ngClass]="{
                                        'no-details': !newReservations[i].locations && !newReservations[i].resources,
                                    }"
                                >
                                    @if (!newReservations[i].locations && !newReservations[i].resources) {
                                        <div class="no-details">No Additional Details Found</div>
                                    }
                                    @for (
                                        location of newReservations[i].locations;
                                        track location.itemId + "-" + i;
                                        let i = $index
                                    ) {
                                        <div>
                                            <s25-item-space
                                                [modelBean]="{ itemId: location.itemId }"
                                                [includeTypeIcon]="true"
                                            ></s25-item-space>
                                        </div>
                                    }
                                    @for (
                                        resource of newReservations[i].resources;
                                        track resource.itemId + "-" + i;
                                        let i = $index
                                    ) {
                                        <div>
                                            <s25-item-resource
                                                [modelBean]="{ itemId: resource.itemId }"
                                                [includeTypeIcon]="true"
                                            ></s25-item-resource>
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (newReservations.length > 1) {
                                <div>
                                    <span class="ngBold ngBlock remove-mapping">
                                        <input
                                            type="checkbox"
                                            id="{{ newReservations[i].start }}"
                                            (change)="onCheck($event, newReservations[i].itemId)"
                                        />
                                        Remove this mapping date
                                    </span>
                                </div>
                            }
                        </div>
                    }
                </section>
            </div>
            <button class="aw-button aw-button--outline c-margin-top--half" (click)="onSubmit()">Submit</button>
        </div>
    } `,
    styles: [
        `
            .copy-segment-container {
                display: flex;
                font-size: 0.9rem;
                font-weight: 400;
            }

            .input-data {
                display: flex;
                flex-direction: column;
                padding-right: 20px;
            }

            .divider {
                border-left: 1px solid #e5e5e5;
            }

            .start-date-container {
                display: flex;
                flex-direction: column;
            }

            .occurrence-view {
                padding-right: 20px;
                max-width: 55em;
                width: fit-content;
                height: fit-content;
                max-height: 26em;
                overflow-y: auto;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
            }

            .original-occurrence {
                padding: 10px;
            }

            .original-occurrence:nth-of-type(even) {
                background-color: rgba(230, 230, 250, 0.5);
            }

            .original-occurrence:not(:last-child) {
                border-bottom: 1px solid #d3d3d3;
            }

            .original-occurrence,
            .mapped-occurrence {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 2em;
            }

            .occurrence-date {
                width: 10em;
            }

            .mapped .occurrence-date {
                position: relative;
                top: 5px;
                width: 15em;
            }

            .mapped .occurrence-date div {
                width: 10em;
            }

            .mapped .occurrence-date span {
                position: relative;
                display: inline-block;
                width: 9em;
            }

            .mapped .occurrence-date span:not(.multi-line) {
                top: 4px;
            }

            .mapped .occurrence-date span.multi-line {
                top: 13px;
            }

            .mapped .multi-line {
                top: 13px;
            }

            .c-svgIcon {
                height: 3em;
                width: 2em;
            }

            .occurrence-objects .no-details {
                position: relative;
                left: 1em;
                font-size: 18px;
                color: #6c6c6c;
            }

            .original-occurrence.date-mapped {
                gap: 1.8em;
            }

            .mapped-occurrence {
                flex-basis: 100%;
                gap: 1em;
            }

            .mapped-occurrence .occurrence-date {
                width: 9em;
            }

            .mapped-occurrence .c-svgIcon {
                position: relative;
                height: 3em;
                width: 2em;
                bottom: 5px;
            }

            :host ::ng-deep .s25-item-holder {
                align-items: flex-start;
                gap: 5px;
                display: flex; /* Use flexbox to arrange child elements in a row */
                flex-wrap: nowrap; /* Prevent wrapping of elements */
            }

            :host ::ng-deep .s25-item-holder .s25-item-label {
                max-width: 21em;
                margin-left: 10px;
            }

            .remove-mapping {
                margin-left: 30px;
                margin-top: -25px;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class EvOccMappingComponent implements OnInit {
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() rsrvs: S25Reservation[];
    @Input() sourceProfileCode?: string;
    @Output() modelValueChange: EventEmitter<dataI> = new EventEmitter<dataI>();

    init: boolean = false;
    showMapping: boolean = true;
    profileName = signal<string>("");
    newProfileId = signal<number>(0);
    mapping: OccurrenceI.Mapping = "one-by-one";
    newRsrvs: S25Reservation[] = [];
    allLocations: S25ItemI[] = [];
    allResources: S25ItemI[] = [];
    newReservations: Reservation[] = []; // temporary  rsrv based on current mapping/date selections for displaying on visual aid
    reservations: Reservation[] = []; //   original rsrv
    dateFormat: string;
    timeFormat: string;
    isMultipleDays: boolean;
    diffStartMins: number = 0;
    diffEndMins: number = 0;
    repetitionText: string;
    removeMappingItems: number[] = [];
    newRsrvProfileCode: string = "";
    newRsrvRepetitionText: string;

    constructor(
        private cd: ChangeDetectorRef,
        private occurrencesService: S25EventOccurrencesService,
    ) {}

    async ngOnInit() {
        if (this.sourceProfileCode !== "") this.repetitionText = EventOccUtil.getRepetitionText(this.sourceProfileCode);
        await this.loadPreferences();
        await this.setupProfile();
        await this.loadReservations();
        this.init = true;
        this.cd.detectChanges();
    }

    async loadPreferences() {
        const [dateFormat, timeFormat] = await Promise.all([
            UserprefService.getS25Dateformat(),
            UserprefService.getS25Timeformat(),
        ]);
        this.dateFormat = dateFormat;
        this.timeFormat = timeFormat;
    }

    async setupProfile() {
        const profileId = await EventService.getNewProfileId();
        this.newProfileId.set(profileId);
        this.profileName.set("Segment_" + profileId);
    }

    async loadReservations() {
        this.rsrvs.sort((a, b) => (a.eventStart as Date).getTime() - (b.eventEnd as Date).getTime());
        this.diffStartMins = S25Util.date.diffMinutes(this.rsrvs[0].eventStart, this.startDate);
        this.diffEndMins = S25Util.date.diffMinutes(this.rsrvs[0].eventEnd, this.endDate);
        await this.getNewRsrvs();
        const getAllObjs = await S25ReservationUtil.getRsrvsObjects(this.rsrvs, true, false);
        this.allLocations = getAllObjs?.allLocations as S25ItemI[];
        this.allResources = getAllObjs?.allResources as S25ItemI[];
    }

    async onDateTimeChange(newDate: Date, text: "start" | "end") {
        if (text === "start") {
            this.startDate = newDate;
            this.diffStartMins = S25Util.date.diffMinutes(this.rsrvs[0].eventStart, newDate);
        } else {
            this.endDate = newDate;
            this.diffEndMins = S25Util.date.diffMinutes(this.rsrvs[0].eventEnd, newDate);
            this.diffStartMins !== 0 ? (this.showMapping = true) : (this.showMapping = false);
        }
        await this.getNewRsrvs();
        this.showMapping = S25Util.date.getDate(this.endDate) > S25Util.date.getDate(this.startDate);
        this.cd.detectChanges();
    }

    async updateMapping() {
        await this.getNewRsrvs();
        this.cd.detectChanges();
    }

    async getNewRsrvs() {
        let rsrvsIds: number[] = [];
        if (this.newRsrvs?.length > 0) rsrvsIds = await S25Util.toItemIds(this.newRsrvs); // alreay created new set newRsrvs, just update DateTime/mapping changed
        this.newRsrvs = await S25ReservationUtil.duplicateReservations(
            this.rsrvs,
            this.diffStartMins,
            this.mapping,
            this.sourceProfileCode,
            this.diffEndMins,
            rsrvsIds,
        );
        this.reservations = await this.getDisplayData(this.rsrvs);
        this.newReservations = await this.getDisplayData(this.newRsrvs);
        await this.getNewRsrvRepetitionText();
    }

    async getDisplayData(data: S25Reservation[]): Promise<Reservation[]> {
        const results: Reservation[] = [];
        data.forEach((res: S25Reservation, i: number) => {
            const isMultipleDays = S25Util.date.getDate(this.endDate) > S25Util.date.getDate(this.startDate);
            const dateRange =
                isMultipleDays &&
                `${S25Datefilter.transform(res.eventStart, this.dateFormat)} - ${S25Datefilter.transform(
                    res.eventEnd,
                    this.dateFormat,
                )}`;
            this.isMultipleDays = isMultipleDays;
            const [resources, locations] = [
                S25ReservationUtil.getObjectsFlat(res.resources[0]) || [],
                S25ReservationUtil.getObjectsFlat(res.locations[0]) || [],
            ];
            results.push({
                itemId: res.itemId,
                date: dateRange || (S25Datefilter.transform(res.eventStart, this.dateFormat) as string),
                start: S25Datefilter.transform(res.eventStart, this.timeFormat) as string,
                end: S25Datefilter.transform(res.eventEnd, this.timeFormat) as string,
                resources: resources,
                locations: locations,
            });
        });

        return results;
    }

    onSubmit() {
        const newRsrvs = this.newRsrvs.filter((item) => !this.removeMappingItems.includes(item.itemId));
        //occ inline copy segment data, if use somewhere might need to ajust the emit data
        const data: dataI = {
            profileName: this.profileName(),
            profileId: this.newProfileId(),
            newCopyRsrvsData: newRsrvs,
            newProfileCode: this.newRsrvProfileCode,
        };
        this.modelValueChange.emit(data);
    }

    async onCheck($event: boolean, itemId: number) {
        if ($event && !this.removeMappingItems.includes(itemId)) {
            this.removeMappingItems.push(itemId);
        } else {
            const index = this.removeMappingItems.indexOf(itemId);
            if (index !== -1) this.removeMappingItems.splice(index, 1);
        }
        await this.getNewRsrvRepetitionText();

        this.cd.detectChanges();
    }

    async getNewRsrvRepetitionText() {
        if (this.removeMappingItems.length > 0) {
            this.newRsrvRepetitionText = "";
            this.newRsrvProfileCode = "";
            return;
        }
        if (this.sourceProfileCode !== "") {
            let dows = this.newRsrvs.map(
                (rsrv: S25Reservation) => S25Util.date.parseDropTZ(rsrv.eventStart).getDay() as DowNumber,
            );
            dows = S25Util.array.unique(dows).sort();
            const dowsAbbr = dows.map((dow) => BOARD_CONST.dowInt2Abbr[dow]);
            const lastOcc: S25Reservation = this.newRsrvs[this.newRsrvs.length - 1] as S25Reservation;
            this.newRsrvProfileCode = S25ProfileUtil.getNewProfileCode(
                this.sourceProfileCode,
                dowsAbbr,
                lastOcc.eventEnd,
            );
            this.newRsrvRepetitionText = await EventOccUtil.getRepetitionText(this.newRsrvProfileCode);
        }
    }
}
